export const contactData = {
  title: "Lets Talk!",
  name: "Full Name",
  namePlaceHolder: "Yossi Cohen",
  email: "Email Address",
  emailPlaceHolder: "your@email.com",
  subject: "Subject",
  subjectPlaceHolder: "Tell me about your new project",
  message: "Message",
  messagePlaceHolder: "Hi, I'm reaching out to offer you a job...",
  Send: "Send Message",
  messageSentTitle: "Thank you!",
  messageSentContent:
    "Your message has been sent successfully. I’ll get back to you as soon as possible.",
  sending: "Sending...",
};
